import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import { useTranslation } from '../utils/translations'

const Footer = () => {
  const { language } = useLanguage()
  const t = useTranslation(language)
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { path: '/services', key: 'nav.services' },
    { path: '/conseil', key: 'nav.conseil' },
    { path: '/accompagnement', key: 'nav.accompagnement' },
    { path: '/ai-solutions', key: 'nav.aiSolutions' },
    { path: '/partnerships', key: 'nav.partnerships' },
    { path: '/training', key: 'nav.training' },
    { path: '/recruitment', key: 'nav.recruitment' },
    { path: '/about', key: 'nav.about' }
  ]

  return (
    <footer className="bg-gray-600 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <Link to="/" className="flex items-center space-x-3 group">
                          <div className="h-18 flex items-center justify-center transform group-hover:scale-105 transition-transform duration-200">
                            <img 
                              src="/images/logo.webp" 
                              alt="Texaconsult" 
                              className="h-20 w-auto"
                              loading="lazy"
                              decoding="async"
                            />
                          </div>
                        </Link>
            </div>
            <p className="text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          <br/>
  <h3 className="font-heading text-white text-lg mb-4">
    {language === "fr" ? "Réseaux sociaux" : "Social Media"}
  </h3>

  <div className="flex space-x-4">
    <a 
      href="https://web.facebook.com/profile.php?id=61584633632225" 
      target="_blank"
      className="text-gray-300 hover:text-blue-500 transition-colors"
    >
      <i className="fab fa-facebook text-2xl"></i>
    </a>

    <a 
      href="https://www.instagram.com/texaconsult/" 
      target="_blank"
      className="text-gray-300 hover:text-pink-500 transition-colors"
    >
      <i className="fab fa-instagram text-2xl"></i>
    </a>

    <a 
      href="https://www.linkedin.com/in/laguetar-elhoucine-7a013757?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
      target="_blank"
      className="text-gray-300 hover:text-sky-500 transition-colors"
    >
      <i className="fab fa-linkedin text-2xl"></i>
    </a>

  </div>
</div>


          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-white text-lg mb-4">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm hover:text-blue-400 transition-colors duration-200"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-white text-lg mb-4">
              {t('footer.contactTitle')}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Phone size={16} className="text-blue-400" />
                <span className="text-sm">+212 665 117 705</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} className="text-blue-400" />
                <span className="text-sm">+212 661 692 022</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} className="text-blue-400" />
                <span className="text-sm">+212 522 441 629</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={16} className="text-blue-400" />
                <span className="text-sm">contact@texaconsult.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin size={16} className="text-blue-400" />
                <span className="text-sm">
                  {language === 'fr' ? 'Casablanca, Maroc' : 'Casablanca, Morocco'}
                </span>
              </li>
            </ul>
          </div>
        </div>

{/* Social Media */}

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            © {currentYear} <a href='https://lowcostoffices.site/' className="hover:text-blue-400 transition-colors duration-200">lowcostoffices.site</a>. {t('footer.copyright')}
          </p>
        </div>
      </div>

    </footer>
  )
}

export default Footer